export type RetailerLocationStoreGroup =
  | readonly StoreGroupOption[]
  | readonly RetailerLocationOption[]

export type OnRetailerLocationStoreGroupChange = (value: RetailerLocationStoreGroup) => void

export enum OptionType {
  StoreGroup = 'storeGroup',
  RetailerLocation = 'retailerLocation',
}

export type RetailerLocationOption = {
  label: string
  value: string
  type: OptionType
}

export type StoreGroupOption = {
  label: string
  value: string
  retailerLocations: {
    name: string
    id: string
  }[]
  type: OptionType
}

export type GroupedOptions = {
  readonly label: string
  readonly type: OptionType
  readonly options: RetailerLocationStoreGroup
}
